import captureException from 'src/common/utils/captureException';
import { apiRequest } from 'src/common/utils/apiFetch';
import { BlockedTime } from 'src/common/providers/useBookingMotivators';
import { formatDate } from 'src/common/utils/dateHelpers';

async function getBlockedTimesForDate(
  listingId: string,
  date: Date,
): Promise<BlockedTime[]> {
  try {
    const url = `/api/v4/boats/${listingId}/blocked-times/?date=${formatDate(date)}`;
    const response = await apiRequest(url);
    if (response.status === 200) {
      const data: BlockedTime[] = await response.json();
      return data;
    }
    return [];
  } catch (error) {
    captureException(error);
    return [];
  }
}

export default getBlockedTimesForDate;
